/*
 * DefaultPage Messages
 *
 * This contains all the text for the DefaultPage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.DefaultPage.title',
    defaultMessage: 'Default Page',
  },
  description: {
    id: 'app.containers.DefaultPage.description',
    defaultMessage: 'Default Page',
  },
  notFoundTitle: {
    id: 'app.components.DefaultPage.notFoundTitle',
    defaultMessage: 'Not Found',
  },
  notFoundDescription: {
    id: 'app.components.DefaultPage.notFoundDescription',
    defaultMessage: 'This page could not be found.',
  },
});
